import { Link as RouterLink } from 'react-router-dom';

import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import TableCellTypography from 'shared/components/widgets/tabel-cell-typography';
import { ROUTES } from 'constants/routes';
import { Link } from '@mui/material';
import { getAdminStatus } from 'shared/helpers/system/getAdminStatus';

export const systemManagerListColumns: GridColDef[] = [
  {
    field: 'admSeq',
    headerName: 'No', // Number
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 80,
    minWidth: 80,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => (
      <TableCellTypography>
        {params?.row?.id || params?.row?.id === 0 ? params?.row?.id : '--'}{' '}
      </TableCellTypography>
    ),
  },
  {
    field: 'admId',
    headerName: '관리자 아이디', // Administrator ID
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 200,
    minWidth: 200,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => (
      <TableCellTypography>{params.value}</TableCellTypography>
    ),
  },
  {
    field: 'admName',
    headerName: '관리자 이름', // Administrator Name
    headerAlign: 'left',
    align: 'left',
    flex: 2,
    maxWidth: 200,
    minWidth: 200,
    renderCell: (params: GridRenderCellParams) => (
      <TableCellTypography>{params.value}</TableCellTypography>
    ),
  },
  {
    field: 'admEmail',
    headerName: '이메일', // Email
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 340,
    minWidth: 340,
    renderCell: (params: GridRenderCellParams) => (
      <TableCellTypography>{params.value ?? '--'}</TableCellTypography>
    ),
  },
  {
    field: 'admSt',
    headerName: '관리자 상태', //  Administrator Status
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 190,
    minWidth: 190,
    renderCell: (params: GridRenderCellParams) => (
      <TableCellTypography>{getAdminStatus(params.value)}</TableCellTypography>
    ),
  },
  {
    field: 'regDt',
    headerName: '등록일시', // Registration Date
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 240,
    minWidth: 240,
    renderCell: (params: GridRenderCellParams) => (
      <TableCellTypography>{params.value}</TableCellTypography>
    ),
  },
  {
    field: 'action',
    headerName: '',
    headerAlign: 'center',
    align: 'center',
    flex: 1,
    maxWidth: 180,
    minWidth: 180,

    renderCell: (params: GridRenderCellParams) => {
      return (
        <Link
          state={params.row}
          component={RouterLink}
          to={`${ROUTES.SYSTEM.MANAGER.path}/change-information/${params?.row?.admSeq}`}
          underline="none"
          fontSize="14px"
          lineHeight="20px"
          fontWeight={500}
          color="var(--blue-gradient-03)"
        >
          수정
        </Link>
      );
    },
  },
];
